import initLeavePageModal from './list/init-leave-page-modal.js';

const initModals = () => {
  initLeavePageModal();
};

export default initModals;
